// extracted by mini-css-extract-plugin
module.exports = {"btn":"TopTitleComponent_btn__GGAlm","inputSearch":"TopTitleComponent_inputSearch__ZFfMP"};